import React from 'react';

import { Modal as AntdModal, ModalProps } from 'antd';

/**
 * All parameters for the generic modal
 *
 * @param modalTitle: Title of modal displayed
 * @param child: Content of form
 */
interface BaseModalProps {
  width: string | number;
  isVisible: boolean;
  closeModal: () => void;
  children: React.ReactElement;
  antdProps?: ModalProps;
  title?: React.ReactNode;
  className?: string;
}

function BaseModal({
  width,
  isVisible,
  closeModal,
  children,
  antdProps,
  title,
  className,
}: BaseModalProps): React.ReactElement {
  return (
    <AntdModal
      title={title}
      open={isVisible}
      onCancel={closeModal}
      footer={null}
      destroyOnClose={true}
      width={width}
      maskClosable={false}
      className={className}
      {...antdProps}
    >
      {children}
    </AntdModal>
  );
}

export default BaseModal;
